import React from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../paths";

export const BtnVoltarHome = () => {
    const navigate = useNavigate();
    return (
        <button onClick={() => navigate(paths.dashboard)} className="btn btn-ghost">
            Voltar para Home
        </button>
    );
};
